import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEMechatronicsCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Mechatronics Engineering",
    shortName: "B.E. Mechatronics",
    duration: "4 years",
    description: "Interdisciplinary engineering program combining mechanical, electrical, and computer engineering for intelligent systems",
    overview: "Bachelor of Engineering in Mechatronics Engineering (B.E. Mechatronics) is a 4-year undergraduate program that integrates mechanical engineering, electrical engineering, and computer science to design and develop intelligent systems. This course focuses on automation, robotics, control systems, and smart technologies that are essential in modern manufacturing and technology sectors.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in automation and intelligent systems"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Mechatronics",
          "Basic Electrical Engineering"
        ]
      },
      {
        year: 2,
        subjects: [
          "Mechanics of Materials",
          "Electrical Circuits and Machines",
          "Digital Electronics",
          "Programming in C/C++",
          "Sensors and Actuators",
          "Engineering Thermodynamics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Control Systems Engineering",
          "Microprocessors and Microcontrollers",
          "Robotics and Automation",
          "Machine Design",
          "PLC Programming",
          "Industrial Automation"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Robotics",
          "Artificial Intelligence in Mechatronics",
          "IoT and Industry 4.0",
          "Embedded Systems Design",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Mechatronics Engineer",
        "Automation Engineer",
        "Robotics Engineer",
        "Control Systems Engineer",
        "Product Design Engineer",
        "Research and Development Engineer",
        "Systems Integration Engineer",
        "IoT Solutions Engineer"
      ],
      industries: [
        "Automotive Industry",
        "Aerospace and Defense",
        "Manufacturing and Production",
        "Robotics Companies",
        "Electronics and Semiconductors",
        "Medical Device Manufacturing",
        "Research and Development",
        "Start-ups and Innovation Labs"
      ],
      averageSalary: "₹6-12 LPA (Fresher), ₹18-40 LPA (Experienced)",
      topRecruiters: [
        "Bosch, Siemens, ABB",
        "Tata Motors, Mahindra",
        "ISRO, DRDO",
        "Honeywell, Schneider Electric",
        "Intel, Qualcomm",
        "Tesla, Mercedes-Benz"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Coimbatore Institute of Technology",
        location: "Coimbatore",
        fees: "₹3,80,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹12,00,000",
        ranking: "NIRF Ranking: 41"
      },
      {
        name: "VIT University",
        location: "Vellore",
        fees: "₹7,83,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "Kumaraguru College of Technology",
        location: "Coimbatore",
        fees: "₹4,00,000",
        ranking: "NAAC A+ Grade"
      }
    ],

    skills: [
      "Control Systems Design",
      "Programming (C/C++, Python, MATLAB)",
      "PLC and SCADA Programming",
      "CAD/CAM Software",
      "Robotics Programming",
      "Sensor Integration",
      "Embedded Systems",
      "IoT Development",
      "Problem Solving",
      "Systems Integration"
    ],

    futureScope: "Excellent growth prospects with Industry 4.0, IoT, artificial intelligence, and automation becoming integral to all industries worldwide.",

    faqs: [
      {
        question: "What makes Mechatronics different from other engineering branches?",
        answer: "Mechatronics is highly interdisciplinary, combining mechanical, electrical, and computer engineering to create intelligent systems and automated solutions."
      },
      {
        question: "Can I specialize in robotics?",
        answer: "Yes, Mechatronics provides excellent foundation for robotics specialization with advanced courses in robotics, AI, and automation systems."
      },
      {
        question: "What about research opportunities?",
        answer: "Excellent research opportunities in areas like autonomous vehicles, medical robotics, space technology, and AI-driven automation systems."
      },
      {
        question: "Is programming knowledge essential?",
        answer: "Yes, programming skills in languages like C/C++, Python, and MATLAB are crucial for control systems, robotics, and automation applications."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEMechatronicsCoursePage;
